'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var FilledFlatTextField = require('./FilledFlatTextField.js');
var makeStyles = require('../../Styles/makeStyles.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var PhoneNumberMaskedInput = require('./PhoneNumberMaskedInput.js');
var StringHelper = require('../../../common/StringHelper.js');
var EINMaskedInput = require('./EINMaskedInput.js');
var SSNMaskedInput = require('./SSNMaskedInput.js');
var TextField$1 = require('../../../node_modules/@material-ui/core/esm/TextField/TextField.js');
var grey = require('../../../node_modules/@material-ui/core/esm/colors/grey.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Variants = {
  FILLED: {
    key: 'filled',
    component: TextField$1["default"]
  },
  STANDARD: {
    key: 'standard',
    component: TextField$1["default"]
  },
  OUTLINED: {
    key: 'outlined',
    component: TextField$1["default"]
  },
  FILLED_FLAT: {
    key: 'filled-flat',
    component: FilledFlatTextField
  }
};
Object.keys(Variants).map(function (variantKey) {
  return Variants[variantKey].key;
});
var MATERIAL_UI_VARIANTS = [Variants.FILLED.key, Variants.STANDARD.key, Variants.OUTLINED.key];
var useStyles = makeStyles["default"](function (theme) {
  return {
    inputLabel: {
      '&.focused': {
        color: theme.palette.primary.main
      },
      '&.error': {
        color: theme.palette.error.main
      }
    },
    underline: {
      '&:after': {
        borderBottomColor: theme.palette.primary.main,
        borderWidth: '2px'
      }
    },
    superdenseUnderline: {
      '&:before': {
        borderBottomColor: 'transparent'
      },
      '&:hover:before': {
        borderBottomColor: 'transparent !important'
      }
    },
    superdense: {
      paddingTop: 7,
      paddingBottom: 6
    },
    superdenseBorderRadius: {
      borderRadius: 4
    },
    roundMultiline: {
      padding: '8px 0 8px 12px'
    },
    round: {
      borderRadius: 20,
      paddingRight: 0
    },
    root: {}
  };
});
var TextField = React__default["default"].forwardRef(function (_ref, ref) {
  var _Variants$constantize, _classNames, _classNames3;

  var version = _ref.version,
      props = objectWithoutProperties(_ref, ["version"]);

  var _props$InputProps = props.InputProps,
      InputProps = _props$InputProps === void 0 ? {} : _props$InputProps,
      dataTestId = props['data-testid'],
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? Variants.FILLED.key : _props$variant,
      mask = props.mask,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      border = props.border,
      multiline = props.multiline,
      _props$inputProps = props.inputProps;
  _props$inputProps = _props$inputProps === void 0 ? {} : _props$inputProps;

  var inputPropsClassName = _props$inputProps.className,
      restOfInputProps = objectWithoutProperties(_props$inputProps, ["className"]),
      InputLabelProps = props.InputLabelProps,
      restProps = objectWithoutProperties(props, ["InputProps", "data-testid", "variant", "mask", "margin", "border", "multiline", "inputProps", "InputLabelProps"]);

  var _useStyles = useStyles(),
      underline = _useStyles.underline,
      inputLabel = _useStyles.inputLabel,
      superdense = _useStyles.superdense,
      superdenseBorderRadius = _useStyles.superdenseBorderRadius,
      superdenseUnderline = _useStyles.superdenseUnderline,
      roundMultiline = _useStyles.roundMultiline,
      round = _useStyles.round,
      restOfClasses = objectWithoutProperties(_useStyles, ["underline", "inputLabel", "superdense", "superdenseBorderRadius", "superdenseUnderline", "roundMultiline", "round"]);

  var style = InputProps.style;
  var newStyle = {};
  var inputComponent = null;
  var isRound = border === 'round';
  var isSuperDense = margin === 'superdense';
  var textFieldMargin = isSuperDense ? 'none' : margin;
  var Component = ((_Variants$constantize = Variants[StringHelper.constantize(variant)]) === null || _Variants$constantize === void 0 ? void 0 : _Variants$constantize.component) || TextField$1["default"];
  var disableUnderline = null;
  var inputPropsClasses = {
    root: classNames__default["default"]((_classNames = {}, defineProperty(_classNames, superdenseBorderRadius, isSuperDense), defineProperty(_classNames, round, isRound), defineProperty(_classNames, roundMultiline, isRound && multiline), _classNames))
  };

  if (ObjectHelper.isPresent(style)) {
    newStyle = _objectSpread({}, style);
  }

  if (variant === Variants.FILLED.key) {
    newStyle.backgroundColor = grey[100];
  }

  if (mask === 'phone') {
    inputComponent = PhoneNumberMaskedInput;
  } else if (mask === 'ein') {
    inputComponent = EINMaskedInput;
  } else if (mask === 'ssn') {
    inputComponent = SSNMaskedInput;
  }

  if (version === 'v2') {
    var _Variants$variantMUI;

    var variantMUI = props.variant === 'filled-flat' ? 'filled' : props.variant;
    var ComponentV2 = ((_Variants$variantMUI = Variants[variantMUI]) === null || _Variants$variantMUI === void 0 ? void 0 : _Variants$variantMUI.component) || TextField$1["default"];
    return React__default["default"].createElement(ComponentV2, _objectSpread({}, props, {
      variant: variantMUI,
      InputProps: _objectSpread({}, inputComponent && {
        inputComponent: inputComponent
      }, {}, InputProps),
      ref: ref
    }));
  }

  if (variant === Variants.STANDARD.key || variant === Variants.FILLED.key) {
    disableUnderline = isRound;
    inputPropsClasses = _objectSpread({}, inputPropsClasses, {
      underline: classNames__default["default"](underline, defineProperty({}, superdenseUnderline, isSuperDense))
    });
  }

  return React__default["default"].createElement(Component, _objectSpread({}, MATERIAL_UI_VARIANTS.includes(variant) && {
    variant: variant
  }, {
    InputProps: _objectSpread({
      classes: inputPropsClasses
    }, disableUnderline && {
      disableUnderline: disableUnderline
    }, {}, InputProps, {
      style: newStyle
    }, inputComponent && {
      inputComponent: inputComponent
    }),
    inputProps: _objectSpread({
      className: classNames__default["default"]((_classNames3 = {}, defineProperty(_classNames3, superdense, isSuperDense || isRound && !multiline), defineProperty(_classNames3, inputPropsClassName, inputPropsClassName), _classNames3))
    }, restOfInputProps, {
      'data-testid': dataTestId
    }),
    InputLabelProps: _objectSpread({
      classes: {
        root: inputLabel,
        focused: 'focused',
        error: 'error'
      }
    }, InputLabelProps),
    margin: textFieldMargin,
    multiline: multiline,
    classes: restOfClasses
  }, restProps));
});

exports.Variants = Variants;
exports["default"] = TextField;
